"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApplicationError = void 0;
/**
 * Default Application Error class used to surface default error types based on the default error type -> category map.
 */
class DefaultApplicationError extends Error {
    constructor(message, errorType, info) {
        super(message);
        this.errorType = errorType;
        this.category = errorType;
        this.info = info;
        Object.setPrototypeOf(this, DefaultApplicationError.prototype);
    }
}
exports.DefaultApplicationError = DefaultApplicationError;
//# sourceMappingURL=default_application_error.js.map